import { render, staticRenderFns } from "./XmSearchInterval.vue?vue&type=template&id=5c4bba61&scoped=true"
import script from "./XmSearchInterval.vue?vue&type=script&lang=js"
export * from "./XmSearchInterval.vue?vue&type=script&lang=js"
import style0 from "./XmSearchInterval.vue?vue&type=style&index=0&id=5c4bba61&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c4bba61",
  null
  
)

export default component.exports